const languages: { [index: string]: { nativeName: string } } = {
	be: { nativeName: "беларуская мова" },
	ca: { nativeName: "Català" },
	cs: { nativeName: "Čeština" },
	cy: { nativeName: "Cymraeg" },
	da: { nativeName: "dansk" },
	de: { nativeName: "Deutsch" },
	el: { nativeName: "Ελληνικά" },
	en: { nativeName: "English" },
	es: { nativeName: "Español" },
	fi: { nativeName: "Suomi" },
	fr: { nativeName: "Français" },
	hu: { nativeName: "Magyar" },
	is: { nativeName: "Íslenska" },
	it: { nativeName: "Italiano" },
	ja: { nativeName: "日本語" },
	ko: { nativeName: "한국어" },
	nl: { nativeName: "Nederlands" },
	nb_NO: { nativeName: "Norsk (Bokmål)" },
	pdt: { nativeName: "Plautdietsch" },
	pl: { nativeName: "Polski" },
	pt: { nativeName: "Português" },
	ru: { nativeName: "Русский язык" },
	sk: { nativeName: "Slovenčina" },
	sl: { nativeName: "Slovenščina" },
	sr: { nativeName: "Српски / Srpski" },
	sv: { nativeName: "Svenska" },
	ta: { nativeName: "தமிழ்" },
	uk: { nativeName: "українська мова" },
	zgh: { nativeName: "ⵜⴰⵎⴰⵣⵉⵖⵜ ⵜⴰⵏⴰⵡⴰⵢⵜ" },
	"zh-Hans": { nativeName: "简体中文" },
	"zh-Hant": { nativeName: "繁体中文" },
};

export default languages;
